
import { Routes } from '@angular/router';
import { QuoteSummaryComponent } from './quote-summary/quote-summary.component';
import { QuoteAssistSingleApiComponent } from './quote-assist/quote-assist.component';
import { DirectQuoteAssistComponent } from './direct-quote-assist/direct-quote-assist.component';
import { DirectQuoteSummaryComponent } from './direct-quote-summary/direct-quote-summary.component';import { DirectRfqListComponent } from './direct-rfq-list/direct-rfq-list.component';
import { RfqIntakeComponent } from './rfq-intake/rfq-intake.component';
import { RfqDetailsDrawerComponent } from './components/rfq-details-drawer/rfq-details-drawer.component';
import { UiTestDashboardComponent } from './testing/ui-test-dashboard.component';
import { QuoteAssistV2Component } from './quoteAssist-V2/main/quote-assist-v2.component';
import { QuoteAssistVersionComponent } from './quote-assist-version/quote-assist-version.component';
import { NotFoundComponent } from './components/not-found/not-found.component';

export const routes: Routes = [
    { path: '', component: NotFoundComponent },
    { path: '404', component: NotFoundComponent },
    
    { path: 'summary', component: QuoteSummaryComponent },
    { path: 'assist', component: QuoteAssistSingleApiComponent },
    { path: 'direct-rfq-list', component: DirectRfqListComponent },
    { path: 'direct-assist', component: DirectQuoteAssistComponent },
    { path: 'direct-quote-summary', component: DirectQuoteSummaryComponent },
    { path: 'rfq-details-drawer', component: RfqDetailsDrawerComponent },
    { path: 'rfq-intake', component: RfqIntakeComponent },
    { path: 'test', component: UiTestDashboardComponent },
    { path: 'quote-assist-v2', component: QuoteAssistV2Component },
    { path: 'quote-assist-version', component: QuoteAssistVersionComponent },
    { path: '**', redirectTo: '404' }
];
